module.exports = __webpack_public_path__ + "assets/images/stereo-03.965f7aab215644398908a3d89829eb3a.svg";